import React from "react";
import "../../../AllComponentCSS.css";

function JS_Higher_Order_Reference() {
  return (
    <div className="tutorial-page">
      <h1>JS Higher Order Reference</h1>
      <p>This page will cover the Higher Order Reference topic in detail.</p>
    </div>
  );
}

export default JS_Higher_Order_Reference;
